import React from "react";

export default function DataTable({
  columns,
  rows,
  loading,
  emptyLabel = "No results",
  testid = "data-table",
}) {
  return (
    <div className="bg-white border border-[hsl(var(--kb-border))] overflow-x-auto" data-testid={testid}>
      <table className="w-full text-sm">
        <thead className="bg-[hsl(var(--kb-surface-alt))] text-left text-[hsl(var(--kb-muted))]">
          <tr>
            {columns.map((c) => (
              <th key={c.key} className="p-3 font-medium whitespace-nowrap">{c.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr><td colSpan={columns.length} className="p-6 text-center text-[hsl(var(--kb-muted))]">Loading…</td></tr>
          ) : rows.length === 0 ? (
            <tr><td colSpan={columns.length} className="p-6 text-center text-[hsl(var(--kb-muted))]">{emptyLabel}</td></tr>
          ) : (
            rows.map((r, i) => (
              <tr key={r.id || i} className="border-t border-[hsl(var(--kb-border))] hover:bg-[hsl(var(--kb-surface-alt))]/50">
                {columns.map((c) => (
                  <td key={c.key} className="p-3 align-top">{c.render ? c.render(r) : r[c.key]}</td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export function Pagination({ page, limit, total, onPage, testid = "pagination" }) {
  const pages = Math.max(1, Math.ceil(total / limit));
  if (pages <= 1) return null;
  return (
    <div className="flex items-center justify-between mt-4 text-sm" data-testid={testid}>
      <div className="text-[hsl(var(--kb-muted))]">
        Page {page} of {pages} · {total} results
      </div>
      <div className="flex gap-2">
        <button
          className="kb-btn-outline !py-2 !px-3 !text-xs"
          disabled={page <= 1}
          onClick={() => onPage(page - 1)}
          data-testid={`${testid}-prev`}
        >
          Prev
        </button>
        <button
          className="kb-btn-outline !py-2 !px-3 !text-xs"
          disabled={page >= pages}
          onClick={() => onPage(page + 1)}
          data-testid={`${testid}-next`}
        >
          Next
        </button>
      </div>
    </div>
  );
}
